import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  paramsSerializer: { indexes: null },
  withCredentials: true,
});

export const CATEGORIES = ["Ace", "King", "Queen", "Joker"];
export const STAGES = [
  "New Enquiry",
  "Contacted",
  "Followup",
  "Demo Scheduled",
  "Demo Done",
  "Fees Shared",
  "Enrolled",
  "Not Interested",
];
export const CATEGORY_COLORS = {
  Ace: "#2d6a4f",
  King: "#1e3a8a",
  Queen: "#92400e",
  Joker: "#7f1d1d",
};
export const STAGE_COLORS = {
  "New Enquiry": "#334155",
  Contacted: "#4338ca",
  Followup: "#1d4ed8",
  "Demo Scheduled": "#14532d",
  "Demo Done": "#047857",
  "Fees Shared": "#92400e",
  Enrolled: "#166534",
  "Not Interested": "#0f172a",
};
export const SOURCES = ["meta-fb", "meta-ig", "google", "offline", "whatsapp", "inbound_call"];
export const SOURCE_LABEL = {
  "meta-fb": "Meta FB",
  "meta-ig": "Meta IG",
  google: "Google",
  offline: "Offline",
  whatsapp: "WhatsApp",
  inbound_call: "Inbound Call",
};
export const COURSES = ["Digital Marketing", "Data Analytics"];
export const EDUCATION_LEVELS = ["10th Pass", "12th Pass", "Undergraduate", "Graduate", "Postgraduate"];
export const CAREER_GOALS = ["Get a Job", "Start Freelancing", "Grow My Business Online", "Career Switch", "Skill Upgrade"];

export function formatDateIST(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const ist = new Date(d.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(ist.getDate())}/${pad(ist.getMonth() + 1)}/${ist.getFullYear()} ${pad(ist.getHours())}:${pad(ist.getMinutes())}`;
  } catch {
    return iso;
  }
}

const MONTH_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatDayMonIST(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const ist = new Date(d.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    return `${String(ist.getDate()).padStart(2, "0")} ${MONTH_SHORT[ist.getMonth()]}`;
  } catch {
    return "";
  }
}
